const LOGIN = "/login";
const LANDING = "/";
const REGISTER = "/register";
const NOT_FOUND = "*";
const SERVER_ERROR = "/500";
const UNDER_MAINTENANCE = "/maintenance";
const ADMIN_PREFIX = "/admin";
const adminPath = (path) => `${ADMIN_PREFIX}${path}`;
const DASHBOARD = adminPath("/dashboard");
const PROFILE = adminPath("/profile");
const ACTIVITY_LOG = adminPath("/activity-logs");
const CUSTOMER = adminPath("/customers");
const SUPPLIER = adminPath("/suppliers");
const PURCHASE = adminPath("/purchases");
const MATERIAL = adminPath("/materials");
const STOCK_REPORT = adminPath("/stock-reports");
const STOCK_OPNAME = adminPath("/stock-opnames");
const INVENTORY_INSIGHT = adminPath("/inventory-insights");
const STOCK_HISTORY = adminPath("/stock-histories");
const STOCK_TRANSFER = adminPath("/stock-transfers");
const SELLER_STOCK = adminPath("/seller-stocks");
const PRODUCTION = adminPath("/productions");
const PRODUCT = adminPath("/products");
const SALE = adminPath("/sales");
const POS = adminPath("/pos");
const AI_ASSISTANT = adminPath("/assistant");
const REPORT = adminPath("/reports");
const FINANCE = adminPath("/finance");
const CASH_BANK = adminPath("/finance/cash-bank");
const OPERATIONAL_EXPENSE = adminPath("/finance/operational-expenses");
const FIXED_ASSET = adminPath("/finance/fixed-assets");
const REPORT_INCOME = adminPath("/reports/income");
const REPORT_EXPENSE = adminPath("/reports/expense");
const REPORT_RECEIVABLE = adminPath("/reports/receivables");
const REPORT_PAYABLE = adminPath("/reports/payables");
const TESTING_PRINT_INVOICE = adminPath("/sales/print-invoice/:id");
const MASTER_STORES = adminPath("/master/stores");
const MASTER_OUTLETS = adminPath("/master/outlets");
const MASTER_ACCOUNTS = adminPath("/master/accounts");
const MASTER_UNITS = adminPath("/master/units");
const MASTER_CATEGORIES = adminPath("/master/categories");
const MASTER_CATEGORY_TYPES = adminPath("/master/category-types");
const MASTER_PRODUCT_CATEGORIES = adminPath("/master/product-categories");
const MASTER_MATERIAL_CATEGORIES = adminPath("/master/material-categories");
const MASTER_ROLES = adminPath("/master/role-permission/roles");
const MASTER_PERMISSIONS = adminPath("/master/role-permission/permissions");
const MASTER_INVITATION_PACKAGES = adminPath("/master/invitation/packages");
const MASTER_INVITATION_SERVICES = adminPath("/master/invitation/services");
const MASTER_INVITATION_SONGS = adminPath("/master/invitation/songs");
const MASTER_INVITATION_TAGS = adminPath("/master/invitation/tags");
const MASTER_INVITATION_TEMPLATES = adminPath("/master/invitation/templates");
const MASTER_REGEION_PROVINCES = adminPath("/master/region/provinces");
const MASTER_REGEION_CITIES = adminPath("/master/region/cities");
const MASTER_REGEION_DISTRICTS = adminPath("/master/region/districts");
const MASTER_REGEION_VILLAGES = adminPath("/master/region/villages");

const PATH_URL = {
  ACTIVITY_LOG,
  ADMIN_PREFIX,
  LOGIN,
  LANDING,
  REGISTER,
  NOT_FOUND,
  UNDER_MAINTENANCE,
  SERVER_ERROR,
  DASHBOARD,
  PROFILE,
  MASTER_STORES,
  MASTER_OUTLETS,
  MASTER_ROLES,
  MASTER_PERMISSIONS,
  MASTER_ACCOUNTS,
  MASTER_UNITS,
  MASTER_CATEGORIES,
  MASTER_CATEGORY_TYPES,
  MASTER_PRODUCT_CATEGORIES,
  MASTER_MATERIAL_CATEGORIES,
  MASTER_INVITATION_PACKAGES,
  MASTER_INVITATION_SERVICES,
  MASTER_INVITATION_SONGS,
  MASTER_INVITATION_TAGS,
  MASTER_INVITATION_TEMPLATES,
  MASTER_REGEION_PROVINCES,
  MASTER_REGEION_CITIES,
  MASTER_REGEION_DISTRICTS,
  MASTER_REGEION_VILLAGES,
  CUSTOMER,
  SUPPLIER,
  PURCHASE,
  TESTING_PRINT_INVOICE,
  MATERIAL,
  STOCK_REPORT,
  STOCK_OPNAME,
  INVENTORY_INSIGHT,
  STOCK_HISTORY,
  STOCK_TRANSFER,
  SELLER_STOCK,
  PRODUCTION,
  PRODUCT,
  SALE,
  POS,
  AI_ASSISTANT,
  REPORT,
  FINANCE,
  CASH_BANK,
  OPERATIONAL_EXPENSE,
  FIXED_ASSET,
  REPORT_INCOME,
  REPORT_EXPENSE,
  REPORT_RECEIVABLE,
  REPORT_PAYABLE,
};
export default PATH_URL;
